import { render, staticRenderFns } from "./MediaPartnerForm.vue?vue&type=template&id=4851fd74"
import script from "./MediaPartnerForm.vue?vue&type=script&lang=js"
export * from "./MediaPartnerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports